import { PropsWithChildren } from 'react';
import { TimeLine } from '@features/components/CaseCard/types';
import { CardTimeline } from '@features/components/CaseCard/Blocks/Timeline/CardTimeline';
import { getColorsByOrganType } from '@/utils/helpers';
import { BaseCaseCard, BaseCaseCardProps } from './BaseCaseCard';

export type CaseCardWithTimelineProps = {
  operationTimeline: TimeLine;
  extraHeight: number;
} & BaseCaseCardProps;

export const CaseCardWithTimeline = ({
  caseData,
  extraHeight,
  operationTimeline,
  children,
  onClick,
}: CaseCardWithTimelineProps & PropsWithChildren) => {
  const colors = getColorsByOrganType(caseData.organType);
  return (
    <BaseCaseCard extraHeight={extraHeight} caseData={caseData} onClick={onClick}>
      <CardTimeline color={colors.bg60} operationTimeline={operationTimeline} />
      {children}
    </BaseCaseCard>
  );
};
